import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    padding: 20,
  },
}));

export default function SimpleModal(props) {
  const { src, src_min } = props;

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <img
        src={src_min}
        onClick={handleOpen}
        style={{
          maxWidth: "calc(100% )",
          borderRadius: 7,
          border: "black 1px solid",
        }}
        alt={"Afbeelding van een unimog"}
        onError={(e) => {
          e.target.onError = null;
          e.target.src =
            "/media/Model_images/Placeholder.jpg";
        }}
      ></img>
      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
          }}
          className={classes.paper}
        >
          <img
            src={src}
            alt={"Afbeelding van een unimog"}
            onError={(e) => {
              e.target.onError = null;
              e.target.src =
                "/media/Model_images/Placeholder.jpg";
            }}
          ></img>
        </div>
      </Modal>
    </div>
  );
}
